import type { FiltersData } from '../types/Filters'
import { fetcher } from './fetcher'

export async function getServerFiltersData({
	channel,
	country,
	catalogId,
	language,
	customDate,
	isClient = false,
}: {
	channel: string
	country: string
	catalogId: string
	language: string
	customDate: Date | null
	isClient: boolean
}): Promise<FiltersData> {
	return fetcher(
		`/channels/${channel}/countries/${country}/catalogs/${catalogId}/filters`,
		language,
		{ customDate },
		isClient
	)
}
